import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { axiosInstance } from '../../functions/axios';
import { DefaultTable } from '../../components/Table/DefaultTable';
import multiplePaymentsColumns from './multiplePaymentsColumns';
import { Link } from 'react-router-dom';
import { LabelBox } from '../Box/LabelBox';
import EnrichWithExistingAccountFields from './EnrichWithExistingAccountFields';
import CustomerLogo from '../CustomerLogo/CustomerLogo';
import {
    Box,
    Button,
    Checkbox,
    Grid,
    TextInput,
    Text,
    InlineNotification,
    SystemNotification,
    Typography,
    List,
    ListItem,
    ContextualNotification,
    Modal,
    Field,
    FieldLabel,
} from '@blueprint/ui';
import { InlineNotificationComponent } from '../Notification/InlineNotificationComponent';
import { setStagePaymentId } from '../../actions/index';
import { NativeDropdown } from '../NativeDropdown/NativeDropdown';
import { HoverTip } from '../HoverTip/HoverTip';
import { NativeCheckbox } from '../NativeCheckbox/NativeCheckbox';

const PaymentBankDetailsPlaceholder = styled.div`
    padding-top: 100px;
    padding-right: 5vw;
    padding-left: 5vw;
    padding-bottom: 5em;
`;

const PaymentBankDetails = ({ location }) => {
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const FETCH_TRANSACTIONS_URL = process.env.REACT_APP_FETCH_TRANSACTIONS_URL;
    const FETCH_WALLET_COUNTRIES_URL = process.env.REACT_APP_FETCH_WALLET_COUNTRIES_URL;
    const FETCH_WALLET_CONFIGURATION_URL = process.env.REACT_APP_FETCH_WALLET_CONFIGURATION_URL;
    const FETCH_AMOUNTS_URL = process.env.REACT_APP_FETCH_AMOUNTS_URL;
    const SUBMIT_PAYMENT_URL = process.env.REACT_APP_SUBMIT_PAYMENT_URL;
    const CONFIRM_OTP_URL = process.env.REACT_APP_CONFIRM_OTP_URL;
    const SHOW_PAYPAL_URL = process.env.REACT_APP_SHOW_PAYPAL_URL;
    const FETCH_BANK_COUNTRIES_URL = process.env.REACT_APP_FETCH_BANK_COUNTRIES_URL;
    const FETCH_BANK_CONFIGURATION_URL = process.env.REACT_APP_FETCH_BANK_CONFIGURATION_URL;
    const EBD_API_URL = process.env.REACT_APP_EBD_API_URL;
    const RESEND_OTP_URL = process.env.REACT_APP_RESEND_OTP_URL;
    const BANK_ACCOUNT_LIST_URL = process.env.REACT_APP_BANK_ACCOUNT_LIST_URL;
    const BANK_ACCOUNT_DETAILS_URL = process.env.REACT_APP_BANK_ACCOUNT_DETAILS_URL;
    const globalState = useSelector((state) => state);
    const isRegisteredUser = useSelector((state) => state.beneDetails.registeredUser);
    const footerHeight = globalState.beneDetails.footerHeight;
    const ACCOUNT_HISTORY = process.env.REACT_APP_ACCOUNT_HISTORY;

    useEffect(() => {
        if (!globalState.beneDetails.details.isLogged) {
            history.push('/');
        }
    }, [globalState, history]);

    //For storing data
    const [userData, setUserData] = useState({
        payer_name: '',
        amount: '',
        currency: '',
        payment_details: '',
        payer_reference: '',
        txn_type: '',
    });
    const [countriesListData, setCountriesListData] = useState({});
    const [countriesList, setCountriesList] = useState([]);

    const [bankFieldsName, setBankFieldsName] = useState([
        {
            accountFormat: 'IBAN',
            clearingFormat: 'BIC',
            addressRequired: false,
        },
    ]);

    const [addressRequired, setAddressRequired] = useState(false);
    const [isOpen, setOpen] = useState(false); // For Modal ( Shown when EBD API Unreachable )
    const [currencyList, setCurrencyList] = useState([]); // Used to populate Dropdown
    const [showPaypalDetails, setShowPaypalDetails] = useState(false); // To hide and show for Demo
    const [showBankDetails, setShowBankDetails] = useState(false); // To hide an show on Button Click
    const [saveBankDetails, setSaveBankDetails] = useState(false); // For Save Bank Details Checkbox
    const [showAdvanceBankDetails, setShowAdvanceBankDetails] = useState(false); //for showing advance bank details
    const [showAdvanceWalletDetails, setShowAdvanceWalletDetails] = useState(false); //for showing advance wallet details
    const [showCurrencyD, setShowCurrencyD] = useState(false); //for showing wallet currecy dropdown
    const [disableTF, setdisableTF] = useState(false); //for enabling/disabling text fields
    const [confirmDetails, setConfirmDetails] = useState(false); // For Confirm Details Checkbox
    const [hideButtons, setHideButtons] = useState(false); // For Hiding Cancel/Continue Buttons
    const [showPassword, setshowPassword] = useState(false); // For showing Password fields
    const [showAC, setShowAC] = useState(false);
    const [country, setCountry] = useState(false);
    const [receiveCurrency, setReceiveCurrency] = useState(null);
    const [walletLabel, setWalletLabel] = useState('');
    const [amount, setAmount] = useState();
    const [fxRate, setFxRate] = useState();
    const [rateId, setRateId] = useState('');
    const [paypalEmailId, setPaypalEmailId] = useState('');
    const [submitAPIResponse, setSubmitAPIResponse] = useState();
    const [otp, setOtp] = useState('');
    const [checkCurrency, setCheckCurrency] = useState(false);
    const [currencyError, setCurrencyError] = useState('');
    const [showEmailError, setShowEmailError] = useState(true);
    const [emailError, setEmailError] = useState('');
    const [showOtpError, setShowOtpError] = useState(true);
    const [otpError, setOtpError] = useState('');
    const [showSubmitPaymentError, setShowSubmitPaymentError] = useState(false);
    const [submitPaymentError, setSubmitPaymentError] = useState('');
    const [showPaypalButton, setShowPaypalButton] = useState(false);
    const [singlePayment, setSinglePayment] = useState(true);
    const [transactions, setTransactions] = useState([]);
    const [showAccountType, setShowAccountType] = useState(false);
    const [accountTypeList, setAccountTypeList] = useState([]);
    const [showCanadaImage, setShowCanadaImage] = useState(false);
    const [customerAddress, setCustomerAddress] = useState({
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        addressLine4: null,
        addressLine5: null,
        buildingNumber: null,
        ctrySubDivision: null,
        postalCode: null,
        streetNumber: null,
        townName: null,
    });
    const [customerAddressValidation, setCustomerAddressValidation] = useState({
        streetNumber: false,
        addressLine1: false,
        townName: false,
        buildingNumber: false,
        ctrySubDivision: false,
        postalCode: false,
    });
    const [bankAccDetails, setBankAccDetails] = useState({
        accountNumber: null,
        bankBic: null,
        bankClearingCode: null,
        bankCountryCode: null,
        ibanAccountNumber: null,
        bankAccountType: null,
    });
    const [bankAccDetailsValidation, setBankAccDetailsValidation] = useState({
        accountNumber: false,
        bankBic: false,
        bankClearingCode: false,
        bankCountryCode: false,
        ibanAccountNumber: false,
        bankAccountType: false,
    });
    const [bankAccDetailsErrors, setBankAccDetailsErrors] = useState({
        accountNumber: '',
        bankBic: '',
        bankClearingCode: '',
        bankCountryCode: '',
        ibanAccountNumber: '',
        bankAccountType: '',
    });
    const [disablePaypalEmailAndButtons, setDisablePaypalEmailAndButtons] = useState(false);
    const [showPrivacyNoticeError, setShowPrivacyNoticeError] = useState(false);
    const [showPrivacyNoticeBanner, setShowPrivacyNoticeBanner] = useState(false);

    /**@returns {boolean} - true if email is valid format, false if email is empty or in invalid format*/
    const validatePaypalEmail = () => {
        var isValid = true;
        if (paypalEmailId === '' || paypalEmailId === null) {
            isValid = false;
            setShowEmailError(true);
            setEmailError(t('loginPage.email_error'));
            return isValid;
        }

        if (paypalEmailId !== '' || paypalEmailId !== null) {
            let pattern = new RegExp(
                /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
            );

            if (!pattern.test(paypalEmailId)) {
                isValid = false;
                setShowEmailError(true);
                setEmailError(t('loginPage.email_error'));
                return isValid;
            } else {
                isValid = true;
                setShowEmailError(false);
                return isValid;
            }
        } else {
            isValid = true;
            setShowEmailError(false);
            return isValid;
        }
    };

    /**@returns {boolean} - returns true if OTP is not empty, false if OTP is empty */
    const validateOTP = () => {
        var isValid = true;

        if (otp === '' || otp === null) {
            isValid = false;
            setShowOtpError(true);
            setOtpError(t('paymentBankDetails.pleaseEnterOTP'));
            return isValid;
        } else {
            isValid = true;
            setShowOtpError(false);
            setOtpError('');
            return isValid;
        }
    };

    /**@returns {boolean} - returns true if address is valid, false if invalid
     * Address is considered valid if mandatory fields are non empty
     */
    const validateAddress = () => {
        var isValid = true;
        if (addressRequired) {
            const addressErrorJson = {
                streetNumber: false,
                addressLine1: false,
                townName: false,
                buildingNumber: false,
                ctrySubDivision: false,
                postalCode: false,
            };

            if (customerAddress.buildingNumber === null || customerAddress.buildingNumber === '') {
                addressErrorJson.buildingNumber = true;
                customerAddressValidation.buildingNumber = true;
                isValid = false;
            }

            if (customerAddress.addressLine1 === null || customerAddress.addressLine1 === '') {
                addressErrorJson.addressLine1 = true;
                isValid = false;
            }

            if (customerAddress.townName === null || customerAddress.townName === '') {
                addressErrorJson.townName = true;
                isValid = false;
            }

            if (customerAddress.buildingNumber === null || customerAddress.buildingNumber === '') {
                addressErrorJson.buildingNumber = true;
                isValid = false;
            }

            if (customerAddress.ctrySubDivision === null || customerAddress.ctrySubDivision === '') {
                addressErrorJson.ctrySubDivision = true;
                isValid = false;
            }

            if (customerAddress.postalCode === null || customerAddress.postalCode === '') {
                addressErrorJson.postalCode = true;
                isValid = false;
            }

            console.log('Address Error Flag JSON', addressErrorJson);

            setCustomerAddressValidation({
                ...customerAddressValidation,
                ...addressErrorJson,
            });
        }

        return isValid;
    };

    // Ensures that Bank Details entered by Beneficiary are not null
    /**@param {boolean}
     * @returns {boolean} */
    const validateBankAccount = (showError) => {
        var isValid = true;

        const errorFlagJson = {
            accountNumber: false,
            bankBic: false,
            bankClearingCode: false,
            bankCountryCode: false,
            ibanAccountNumber: false,
            bankAccountType: false,
        };

        const errorMessagesJson = {
            accountNumber: '',
            bankBic: '',
            bankClearingCode: '',
            bankCountryCode: '',
            ibanAccountNumber: '',
            bankAccountType: '',
        };

        if (bankFieldsName[0].accountFormat === 'IBAN') {
            if (bankAccDetails.ibanAccountNumber === '' || bankAccDetails.ibanAccountNumber === null) {
                errorFlagJson.ibanAccountNumber = true;
                errorMessagesJson.ibanAccountNumber = t('paymentBankDetails.ibanCannotBeEmpty');
                isValid = false;
            }
        } else {
            if (bankAccDetails.accountNumber === '' || bankAccDetails.accountNumber === null) {
                errorFlagJson.accountNumber = true;
                errorMessagesJson.accountNumber = t('paymentBankDetails.accountNumberCannotBeEmpty');
                isValid = false;
            }
        }

        if (bankFieldsName[0].clearingFormat === 'BIC') {
            if (bankAccDetails.bankBic === '' || bankAccDetails.bankBic === null) {
                errorFlagJson.bankBic = true;
                errorMessagesJson.bankBic = t('paymentBankDetails.clearingFormatCannotBeEmpty', { clearingFormat });
                isValid = false;
            }
        } else {
            if (bankAccDetails.bankClearingCode === '' || bankAccDetails.bankClearingCode === null) {
                errorFlagJson.bankClearingCode = true;
                errorMessagesJson.bankClearingCode = t('paymentBankDetails.clearingFormatCannotBeEmpty', { clearingFormat });
                isValid = false;
            }
        }

        if (showError && showAccountType && (bankAccDetails.bankAccountType === '' || bankAccDetails.bankAccountType === null)) {
            errorFlagJson.bankAccountType = true;
            errorMessagesJson.bankAccountType = t('paymentBankDetails.accountTypeCannotBeEmpty');
            isValid = false;
        }

        console.log('Bank Details Error Flag JSON', errorFlagJson);

        if (showError) {
            if (!ebdError) {
                setBankAccDetailsErrors({
                    ...bankAccDetailsErrors,
                    ...errorMessagesJson,
                });
                setBankAccDetailsValidation({
                    ...bankAccDetailsValidation,
                    ...errorFlagJson,
                });
            }
        }

        return isValid;
    };

    // API Call at Page Load to fetch Transaction Details
    useEffect(() => {
        const fetchTransactionsDetails = async () => {
            try {
                const response = await axiosInstance.post(
                    FETCH_TRANSACTIONS_URL,
                    JSON.stringify({
                        transactionIds: location.state.tnxIds,
                    })
                );
                if (response) {
                    const responseJson = response.data;
                    console.log('Logging FETCH_TRANSACTIONS_URL response', responseJson);
                    if (response.status !== 200) {
                    } else {
                        if (responseJson.transactions.length === 1) {
                            setSinglePayment(true);
                            setUserData({
                                ...userData,
                                payer_name: responseJson.customerName,
                                amount: responseJson.transactions[0].instructedAmount,
                                currency: responseJson.transactions[0].instructedCurrency,
                                payment_details: responseJson.transactions[0].custBeneInfo,
                                payer_reference: responseJson.transactions[0].custPaymentRef,
                                txn_type: responseJson.transactions[0].transactionType,
                            });

                            // FOR FETHCING ACCOUNTS
                            let requestBody = {};
                            console.log('Txn type is', responseJson.transactions[0].transactionType);
                            if (responseJson.transactions[0].transactionType === 'FIXED_CREDIT') {
                                console.log('coming in fc', userData);
                                requestBody.currency = responseJson.transactions[0].instructedCurrency;
                            }
                            fetchAccounts(requestBody);
                        } else {
                            setUserData({
                                ...userData,
                                payer_name: responseJson.customerName,
                                currency: responseJson.instructedCurrency,
                                txn_type: responseJson.transactionType,
                            });

                            setTransactions(responseJson.transactions);
                            console.log('Logging Transactions from FETCH_TRANSACTIONS_URL response', responseJson.transactions);
                            setSinglePayment(false);
                            let requestBody = {
                                // emailId: globalState.beneDetails.details.emailId,
                            };

                            if (responseJson.transactions[0].transactionType === 'FIXED_CREDIT') {
                                console.log('coming in fc', userData);
                                requestBody.currency = responseJson.transactions[0].instructedCurrency;
                            }
                            fetchAccounts(requestBody);
                        }

                        let transactionCurrency = null;
                        if (responseJson.transactionType === 'FIXED_CREDIT') {
                            transactionCurrency = responseJson.instructedCurrency;
                        }

                        try {
                            const showPaypalResponse = await axiosInstance({
                                method: 'get',
                                url: SHOW_PAYPAL_URL,
                                params: {
                                    custId: location.state.custId,
                                    currency: transactionCurrency,
                                },
                            });

                            if (showPaypalResponse.status === 200) {
                                setShowPaypalButton(showPaypalResponse.data);
                            }
                        } catch (error) {
                            console.log('Logging SHOW_PAYPAL_URL failure', error.response);
                        }
                    }
                }
            } catch (error) {
                console.log('Logging FETCH_TRANSACTIONS_URL error', error);
            }
        };
        fetchTransactionsDetails();
    }, []);

    // State variables for Registered user

    // This state variable will store the List of Registered Accounts (Bank + Wallet)
    const [accountList, setAccountList] = useState([]);

    // This state variable will decide whether to show existing account fields or not
    const [showEnrichExistingFields, setShowEnrichExistingFields] = useState(false);

    // This state variable will store the Account which beneficiary selected using the Dropdown menu
    const [selectedRegisteredAccount, setSelectedRegisteredAccount] = useState({ label: 'Pay to Existing Bank or Paypal Account', value: null });

    // This state variable will store the type of account which beneficiary selected using Dropdown menu
    // (Used to determine whether to call Bank configuration API or Wallet Configuration API)
    // Can be 'bank' or 'wallet'
    const [selectedRegisteredAccountType, setSelectedRegisteredAccountType] = useState(null);

    // This state variable will store Account details of the account which beneficiary selected using dropdown menu
    // Updated only after API call is received
    const [selectedAccountDetails, setSelectedAccountDetails] = useState({
        accountId: null,
        emailId: null,
        countryCode: null,
        accountCurrencycode: null,
        bankAccount: {
            bankBic: null,
            accountNumber: null,
            bankClearingCode: null,
            ibanAccountNumber: null,
            bankAccountType: null,
        },
        wallet: { walletType: null, walletAccountType: null, walletAccountValue: null },
        address: {
            addressLine1: null,
            addressLine2: null,
            addressLine3: null,
            addressLine4: null,
            addressLine5: null,
            buildingNumber: null,
            ctrySubDivision: null,
            postalCode: null,
            streetNumber: null,
            townName: null,
        },
    });

    const [amountFxRate, setAmountFxRate] = useState({
        totalAmount: null,
        fxRate: null,
        rateId: null,
    });
    const [bankConfiguration, setBankConfiguration] = useState([
        {
            countryCode: null,
            countryName: null,
            currencyCode: null,
            clearingFormat: null,
            clearingMinLen: null,
            clearingMaxLen: null,
            clearingCharSet: null,
            accountFormat: null,
            accountMinLen: null,
            accountMaxLen: null,
            accountCharSet: null,
            accountTypes: [],
            addressRequired: false,
        },
    ]);
    const [walletConfiguration, setWalletConfiguration] = useState([
        {
            id: null,
            currencyCode: null,
            countryCode: null,
            countryName: null,
            walletType: null,
            walletAccountType: null,
            walletLabel: null,
            minLen: null,
            maxLen: null,
            accountCharSet: null,
            addressRequired: null,
        },
    ]);

    // If user is Registered user then fetch his accounts

    const fetchAccounts = async (requestBody) => {
        if (isRegisteredUser) {
            try {
                const response = await axiosInstance.post(BANK_ACCOUNT_LIST_URL, JSON.stringify(requestBody));
                if (response.status === 200) {
                    console.log(`Logging ${BANK_ACCOUNT_LIST_URL} success`, response.data);
                    let bankAccountList = response.data.map((account) => {
                        let bankAccount = {
                            label: account.value,
                            value: account.accountId,
                        };
                        return bankAccount;
                    });

                    console.log('The length of bank accounts is', location.state, bankAccountList);
                    setAccountList(bankAccountList);
                    setShowEnrichExistingFields(true);
                }
            } catch (error) {
                console.log(`Logging error fromm`, error);
            }
        }
    };

    useEffect(() => {
        const fetchAccount = async () => {
            try {
                const response = await axiosInstance.get(`${BANK_ACCOUNT_DETAILS_URL}/${selectedRegisteredAccount.value}`);
                if (response.status === 200) {
                    console.log(`Logging ${BANK_ACCOUNT_DETAILS_URL} success`, response.data);
                    if (response.data.bankAccount !== null && response.data.wallet === null) {
                        console.log('Selected registered account type set to BANK');
                        setSelectedRegisteredAccountType('bank');
                    } else {
                        console.log('Selected registered account type set to WALLET');
                        setSelectedRegisteredAccountType('wallet');
                    }
                    setSelectedAccountDetails(response.data);
                }
            } catch (error) {
                console.log(`Logging ${BANK_ACCOUNT_DETAILS_URL} error`, error);
            }
        };
        if (selectedRegisteredAccount.value) {
            fetchAccount();
        }
    }, [selectedRegisteredAccount]);

    useEffect(() => {
        const fetchBankAccountConfiguration = async () => {
            try {
                const response = await axiosInstance({
                    method: 'get',
                    url: FETCH_BANK_CONFIGURATION_URL,
                    params: {
                        country: selectedAccountDetails.countryCode,
                        currency: selectedAccountDetails.accountCurrencycode,
                    },
                });

                if (response.status === 200) {
                    console.log(`Logging ${FETCH_BANK_CONFIGURATION_URL} success`, response.data);
                    setBankConfiguration(response.data);
                }
            } catch (error) {
                console.log(`Logging ${FETCH_BANK_CONFIGURATION_URL} error`, error);
            }
        };
        const fetchWalletConfiguration = async () => {
            try {
                const response = await axiosInstance({
                    method: 'get',
                    url: FETCH_WALLET_CONFIGURATION_URL,
                    params: {
                        country: selectedAccountDetails.countryCode,
                        currency: selectedAccountDetails.accountCurrencycode,
                    },
                });
                if (response.status === 200) {
                    console.log(`Logging ${FETCH_WALLET_CONFIGURATION_URL} success`, response.data);
                    setWalletConfiguration(response.data);
                }
            } catch (error) {
                console.log(`Logging ${FETCH_WALLET_CONFIGURATION_URL} error`, error);
            }
        };

        if (selectedRegisteredAccountType === 'bank') {
            fetchBankAccountConfiguration();
        } else if (selectedRegisteredAccountType === 'wallet') {
            fetchWalletConfiguration();
        } else {
            console.log('User hasnt selected Account yet');
        }
    }, [selectedAccountDetails]);

    useEffect(() => {
        const fetchAmountFxRate = async () => {
            try {
                let requestBody = {
                    receiveCurrency: selectedAccountDetails.accountCurrencycode,
                    transactionIds: location.state.tnxIds,
                };
                const response = await axiosInstance.post(FETCH_AMOUNTS_URL, JSON.stringify(requestBody));
                if (response.status === 200) {
                    console.log(`Logging ${FETCH_AMOUNTS_URL} success`, response.data);
                    setAmountFxRate(response.data);
                }
            } catch (error) {
                console.log(`Logging ${FETCH_AMOUNTS_URL} error`, error);
            }
        };
        if (selectedRegisteredAccount.value) fetchAmountFxRate();
    }, [selectedAccountDetails]);

    const handleRegisteredAccountChange = (SelectedOption, event) => {
        setShowBankDetails(false);
        setShowPaypalDetails(false);
        setShowAdvanceBankDetails(false);
        setShowAdvanceWalletDetails(false);
        setSelectedRegisteredAccount(SelectedOption);
        setShowEnrichExistingFields(true);
        setshowPassword(false);
        setPaymentMethod('');
        setDisablePaypalEmailAndButtons(false);
        console.log('Selected Registered Account is', SelectedOption);
    };

    // Sets Bank Account Details based on user input
    const handleBankAccountUserInput = (event, name, ebd = false) => {
        if (!ebd) {
            const value = event.value;
            if (value !== '') {
                setBankAccDetailsValidation({
                    ...bankAccDetailsValidation,
                    [name]: false,
                });
            }

            setBankAccDetails({
                ...bankAccDetails,
                [name]: value,
            });
        } else {
            const newEbdApiBody = {
                accountCurrencycode: receiveCurrency,
                accountNumber: bankAccDetails.accountNumber,
                bankAccountType: bankAccDetails.accountType,
                bankBic: bankAccDetails.bankBic,
                bankClearingCode: bankAccDetails.bankClearingCode,
                bankCountryCode: country.value,
                ibanAccountNumber: bankAccDetails.ibanAccountNumber,
            };

            if (JSON.stringify(newEbdApiBody) !== JSON.stringify(ebdApiBody)) {
                callEbdApi();
            }
        }
    };

    // Sets Bank Account Type in case of USA
    const handleBankAccountType = (SelectedOption, event) => {
        setBankAccDetailsValidation({
            ...bankAccDetailsValidation,
            bankAccountType: false,
        });
        setBankAccDetails({
            ...bankAccDetails,
            bankAccountType: SelectedOption.value,
        });
    };

    // Sets Address for Bank Account based on user input
    const handleAddressInput = (event, name) => {
        const value = event.value;
        if (value !== '') {
            setCustomerAddressValidation({
                ...customerAddressValidation,
                [name]: false,
            });
        }
        setCustomerAddress({
            ...customerAddress,
            [name]: value,
        });
    };

    const setCountriesFromRes = (responseJson) => {
        let uniqueObject = {};
        let newArray = [];
        for (let i in responseJson) {
            const objTitle = responseJson[i]['countryName'];
            uniqueObject[objTitle] = responseJson[i];
        }

        for (let i in uniqueObject) {
            newArray.push(uniqueObject[i]);
        }
        console.log('Logging countries array length', newArray.length);
        setCountriesList(
            newArray.map((name) => ({
                label: name.countryName,
                value: name.countryCode,
            }))
        );
    };
    const [paymentMethod, setPaymentMethod] = useState('');
    useEffect(() => {
        console.log('Payment Method is', paymentMethod);
    }, [paymentMethod]);

    const handleWallet = () => {
        setPaymentMethod('Paypal');
        if (showPaypalDetails) {
            return;
        }
        resetBankAccState();
        setCountry(null);
        setReceiveCurrency(null);
        setCheckCurrency(false);
        setShowPaypalDetails(true);
        setShowPrivacyNoticeBanner(true);
        setShowBankDetails(false);
        setShowAdvanceBankDetails(false);
        setCountriesList([]);
        const fetchWalletCountries = async () => {
            let transactionCurrency = null;
            if (userData.txn_type === 'FIXED_CREDIT') {
                transactionCurrency = userData.currency;
            }
            try {
                const response = await axiosInstance({
                    method: 'get',
                    url: FETCH_WALLET_COUNTRIES_URL,
                    params: {
                        custId: location.state.custId,
                        currency: transactionCurrency,
                        tnxId: location.state.tnxIds[0],
                    },
                });
                if (response) {
                    const responseJson = response.data;
                    console.log('Countries List Data is', responseJson);
                    setCountriesListData(responseJson);
                    if (response.status !== 200) {
                    } else {
                        setCountriesFromRes(responseJson);
                    }
                }
            } catch (error) {
                console.log('Logging FETCH_WALLET_COUNTRIES_URL error', error);
            }
        };
        fetchWalletCountries();
    };

    const handleBankAccount = () => {
        setPaymentMethod('Bank');
        if (showBankDetails) {
            return;
        }
        setCountry(null);
        resetBankAccState();
        setReceiveCurrency(null);
        setShowPrivacyNoticeBanner(true);
        setShowBankDetails(true);
        setShowPaypalDetails(false);
        setShowAdvanceWalletDetails(false);
        setCountriesList([]);
        const fetchBankCountries = async () => {
            let transactionCurrency = null;
            if (userData.txn_type === 'FIXED_CREDIT') {
                transactionCurrency = userData.currency;
            }
            try {
                const response = await axiosInstance({
                    method: 'get',
                    url: FETCH_BANK_COUNTRIES_URL,
                    params: {
                        custId: location.state.custId,
                        currency: transactionCurrency,
                        tnxId: location.state.tnxIds[0],
                    },
                });
                if (response) {
                    const responseJson = response.data;
                    console.log('Logging FETCH_BANK_COUNTRIES_URL response', responseJson);
                    setCountriesListData(responseJson);
                    if (response.status !== 200) {
                    } else {
                        setCountriesFromRes(responseJson);
                    }
                }
            } catch (error) {
                console.log('Logging FETCH_BANK_COUNTRIES_URL error', error);
            }
        };
        fetchBankCountries();
    };

    const [ebdTimeoutMessage, setEbdTimeoutMessage] = useState('');
    const [elementsWithError, setElementsWithError] = useState([]);
    // useEffect(() => {
    //     console.log('Elements with errors are ', elementsWithError);

    //     if (elementsWithError.length > 0) {
    //         console.log('Shifting focus to ',elementsWithError[0]);
    //         elementsWithError[0].focus();
    //     }
    // }, [elementsWithError]);
    const callSubmit = (event) => {
        var requestPayload = {
            fxRate: fxRate,
            transactionIds: location.state.tnxIds,
            rateId: rateId,
            receiveCurrency: receiveCurrency,
            totalAmount: amount,
            accountCurrencycode: receiveCurrency,
            countryCode: country.value,
            custId: location.state.custId,
        };

        //checking for currency
        if (receiveCurrency === null || receiveCurrency === '') {
            setCheckCurrency(true);
            setCurrencyError('Please select currency');
        } else {
            setCheckCurrency(false);
        }

        if (showPaypalDetails) {
            // User has selected Paypal method

            // If privacy notice checkbox is checked then remove error
            if (confirmDetails) {
                setShowPrivacyNoticeError(false);
            }

            let addressValidationError = validateAddress();

            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                    console.log('Logging first element having class hasError', elementsWithError[0]);
                    elementsWithError[0].focus();
                }
            }, 200);

            // Validates PaypalEmailID
            if (!validatePaypalEmail() || !confirmDetails || !addressValidationError) {
                if (!validatePaypalEmail()) {
                    console.log('Email is Empty');
                }
                if (!confirmDetails) {
                    setShowPrivacyNoticeError(true);
                    console.log('Privacy notice checkbox isnt ticked');
                }
                return;
            }

            // TODO Add address to request payload
            if (addressRequired) {
                requestPayload.address = customerAddress;
            }

            requestPayload.wallet = {
                walletAccountType: 'EMAIL',
                walletAccountValue: paypalEmailId,
                walletType: 'PAYPAL',
            };
        } else {
            // In case of bank

            // Remove Checkbox Erorr if Checkbox ticked
            if (confirmDetails) {
                setShowPrivacyNoticeError(false);
            }

            // Check if any Bank Account Detail field is empty
            let bankDetailsValidationError = validateBankAccount(true);

            // Check if any mandatory address field is empty
            let addressValidationError = validateAddress();

            let elementsWithError = document.getElementsByClassName('hasError');
            setTimeout(() => {
                if (elementsWithError !== null && elementsWithError !== undefined && elementsWithError.length > 0) {
                    console.log('Logging first element having class hasError', elementsWithError[0]);
                    elementsWithError[0].focus();
                }
            }, 200);

            console.log('Error in Bank Details or Address', !bankDetailsValidationError || !addressValidationError);

            /**
             * Dont allow user to proceed if
             * 1. Any bank account detail is empty
             * 2. Any mandatory address field is empty
             * 3. Checkbox not ticked
             */
            if (!bankDetailsValidationError || !addressValidationError || !confirmDetails) {
                if (!confirmDetails) {
                    setShowPrivacyNoticeError(true);
                }
                return;
            }

            if (addressRequired === true) {
                requestPayload.address = customerAddress;
            }
            requestPayload.bankAccount = bankAccDetails;
            requestPayload.accountValidationId = accountValidationId;
        }

        const submitDetails = async () => {
            console.log('Logging SUBMIT_PAYMENT_URL request payload', requestPayload);
            try {
                const response = await axiosInstance.post(SUBMIT_PAYMENT_URL, JSON.stringify(requestPayload));
                if (response) {
                    const responseJson = response.data;
                    if (response.status === 200) {
                        console.log('Logging SUBMIT_PAYMENT_URL response', responseJson);
                        setSubmitAPIResponse(responseJson);
                        setshowPassword(true);
                        setdisableTF(true);
                        setHideButtons(true);
                        setDisablePaypalEmailAndButtons(true);
                        if (response.data.ebdTimeOutMessage && response.data.ebdTimeOutMessage !== '') {
                            setEbdTimeoutMessage(responseJson.ebdTimeOutMessage);
                            setOpen(true);
                        }
                    }
                }
            } catch (error) {
                console.log('Logging SUBMIT_PAYMENT_URL error', error);
                handleEbdError(error);
            }
        };
        submitDetails();
    };

    const resendOtp = () => {
        const resendOtpCall = async () => {
            try {
                const response = await axiosInstance.post(
                    RESEND_OTP_URL,
                    JSON.stringify({
                        // emailId: globalState.beneDetails.details.emailId,
                        stagePaymentId: submitAPIResponse.stagePaymentId,
                    })
                );
                if (response.status === 200) {
                    console.log('OTP Resent');
                }
            } catch (error) {
                console.log('Logging RESEND_OTP_URL error', error.response);
            }
        };
        resendOtpCall();
    };

    const confirmOtp = (event) => {
        if (!validateOTP()) {
            console.log('OTP is empty');
            return;
        }
        setshowPassword(true);
        setdisableTF(true);
        setHideButtons(true);

        const confirmOtp = async () => {
            try {
                const response = await axiosInstance.post(
                    CONFIRM_OTP_URL,
                    JSON.stringify({
                        // emailId: globalState.beneDetails.details.emailId,
                        stagePaymentId: submitAPIResponse.stagePaymentId,
                        otp: otp,
                    })
                );
                if (response) {
                    const responseJson = response.data;
                    console.log('Logging CONFIRM_OTP_URL response', responseJson);
                    setSubmitAPIResponse(responseJson);
                    dispatch(setStagePaymentId(submitAPIResponse.stagePaymentId));
                    history.push({
                        pathname: '/verifyDetailsConfirm',
                        state: {
                            stagePaymentId: submitAPIResponse.stagePaymentId,
                        },
                    });
                }
            } catch (error) {
                console.log('Logging CONFIRM_OTP_URL error', error);
                setOtp('');
                setShowOtpError(true);
                setOtpError(error.response.data.message);
            }
        };
        confirmOtp();
    };

    const handleEbdError = (error) => {
        const errorFlagJson = {
            accountNumber: false,
            bankBic: false,
            bankClearingCode: false,
            bankCountryCode: false,
            ibanAccountNumber: false,
            bankAccountType: false,
        };

        const errorMessagesJson = {
            accountNumber: '',
            bankBic: '',
            bankClearingCode: '',
            bankCountryCode: '',
            ibanAccountNumber: '',
            bankAccountType: '',
        };
        console.log('Errors sent by EBD API are', error.response.data.errors);
        if (error.response.data && error.response.data.errors) {
            setEbdError(true);
            for (let i = 0; i < error.response.data.errors.length; i++) {
                let errorElement = error.response.data.errors[i];
                if (errorElement.fieldName && errorElement.message && errorElement.fieldName !== 'paypalError') {
                    console.log('Error field name', errorElement.fieldName);
                    errorMessagesJson[errorElement.fieldName] = errorElement.message;
                    errorFlagJson[errorElement.fieldName] = true;
                } else if (errorElement.fieldName && errorElement.message && errorElement.fieldName === 'paypalError') {
                    setShowEmailError(true);
                    setEmailError(errorElement.message);
                }
            }
            setBankAccDetailsErrors({
                ...bankAccDetailsErrors,
                ...errorMessagesJson,
            });
            setBankAccDetailsValidation({
                ...bankAccDetailsValidation,
                ...errorFlagJson,
            });
            console.log('Bank Account Details Validation Flags are', errorFlagJson);
            console.log('Bank Account Detail Error Messages are', errorMessagesJson);
        }
    };

    const [ebdError, setEbdError] = useState(false);
    const [ebdApiBody, setEbdApiBody] = useState(null);
    const [accountValidationId, setAccountValidationId] = useState(null);
    const callEbdApi = () => {
        let isValid = validateBankAccount(false);

        const ebdCall = async () => {
            try {
                const response = await axiosInstance.post(
                    EBD_API_URL,
                    JSON.stringify({
                        accountCurrencycode: receiveCurrency,
                        accountNumber: bankAccDetails.accountNumber,
                        bankAccountType: bankAccDetails.accountType,
                        bankBic: bankAccDetails.bankBic,
                        bankClearingCode: bankAccDetails.bankClearingCode,
                        bankCountryCode: country.value,
                        ibanAccountNumber: bankAccDetails.ibanAccountNumber,
                    })
                );
                if (response.status === 200) {
                    setAccountValidationId(response.data.accountValidationId);
                    console.log('EBD API sent no errors, The response is ', response.data);
                }
            } catch (error) {
                console.log('Logging EBD_API_URL error', error);
                handleEbdError(error);
            }
        };

        if (isValid && country && receiveCurrency) {
            setAccountValidationId(null);
            ebdCall();
            setEbdApiBody({
                accountCurrencycode: receiveCurrency,
                accountNumber: bankAccDetails.accountNumber,
                bankAccountType: bankAccDetails.accountType,
                bankBic: bankAccDetails.bankBic,
                bankClearingCode: bankAccDetails.bankClearingCode,
                bankCountryCode: country.value,
                ibanAccountNumber: bankAccDetails.ibanAccountNumber,
            });
        }
    };

    // Checkboxes events
    const toggleSaveBankDetailsCheckbox = (event) => {
        setSaveBankDetails(event.target.checked);
    };

    useEffect(() => {
        if (confirmDetails) {
            setShowPrivacyNoticeError(false);
        }
    }, [confirmDetails]);

    const toggleConfirmDetailsCheckbox = (event) => {
        setConfirmDetails(event.target.checked);
    };

    const handleReceiveCurrencySelection = (country, currency) => {
        // Country is value only
        console.log('Receive currency is', currency);

        if (currency === userData.currency || userData.txn_type === 'FIXED_CREDIT') {
            setShowAC(false);
        } else {
            setShowAC(true);
        }
        if (showPaypalDetails) {
            setShowAdvanceWalletDetails(true);
            const fetchWalletConfiguration = async () => {
                try {
                    const response = await axiosInstance({
                        method: 'get',
                        url: FETCH_WALLET_CONFIGURATION_URL,
                        params: {
                            country: country,
                            currency: currency,
                        },
                    });
                    if (response) {
                        if (response.status === 200) {
                            const responseJson = response.data[0];
                            setWalletLabel(responseJson.walletLabel);
                            console.log('Logging FETCH_WALLET_CONFIGURATION_URL response', responseJson);
                            setAddressRequired(responseJson.addressRequired);
                        }
                    }
                } catch (error) {
                    console.log('Logging FETCH_WALLET_CONFIGURATION_URL error', error);
                }
            };
            fetchWalletConfiguration();
        } else {
            // setShowAdvanceWalletDetails(false);
            const fetchBankConfiguration = async () => {
                try {
                    const response = await axiosInstance({
                        method: 'get',
                        url: FETCH_BANK_CONFIGURATION_URL,
                        params: {
                            country: country,
                            currency: currency,
                        },
                    });
                    if (response) {
                        if (response.status !== 200) {
                        } else {
                            const responseJson = response.data;
                            console.log('Logging FETCH_BANK_CONFIGURATION_URL response', responseJson);
                            if (responseJson[0].accountTypes !== null && responseJson[0].accountTypes.length > 0) {
                                setShowAccountType(true);
                                setAccountTypeList(
                                    responseJson[0].accountTypes.map((accountType) => ({
                                        label: accountType.value,
                                        value: accountType.code,
                                    }))
                                );
                            } else {
                                setShowAccountType(false);
                                setAccountTypeList([]);
                            }
                            setBankFieldsName(responseJson);
                            setShowAdvanceBankDetails(true);
                            setAddressRequired(responseJson[0].addressRequired);
                        }
                    }
                } catch (error) {
                    console.log('Logging FETCH_BANK_CONFIGURATION_URL error', error);
                }
            };
            fetchBankConfiguration();
        }

        const fetchAmounts = async () => {
            try {
                const response = await axiosInstance.post(
                    FETCH_AMOUNTS_URL,
                    JSON.stringify({
                        // emailId: globalState.beneDetails.details.emailId,
                        transactionIds: location.state.tnxIds,
                        receiveCurrency: currency,
                    })
                );

                if (response) {
                    const responseJson = response.data;
                    console.log('Logging FETCH_AMOUNTS_URL response', responseJson);

                    if (response.status !== 200) {
                    } else {
                        setAmount(responseJson.totalAmount);
                        console.log(amount);
                        setFxRate(responseJson.fxRate);
                        setRateId(responseJson.rateId);
                    }
                }
            } catch (error) {
                console.log('Logging FETCH_AMOUNTS_URL error', error);
            }
        };
        fetchAmounts();
    };

    // Call on BAnk Acc button click
    const resetBankAccState = () => {
        setShowAC(false);
        setShowPrivacyNoticeError(false);
        setShowAdvanceBankDetails(false);
        setCheckCurrency(false);
        setReceiveCurrency(null);
        setBankAccDetailsErrors({
            accountNumber: '',
            bankBic: '',
            bankClearingCode: '',
            bankCountryCode: '',
            ibanAccountNumber: '',
            bankAccountType: '',
        });
        setBankAccDetails({
            accountNumber: '',
            bankBic: '',
            bankClearingCode: '',
            bankCountryCode: '',
            ibanAccountNumber: '',
            bankAccountType: '',
        });
        setBankAccDetailsValidation({
            accountNumber: false,
            bankBic: false,
            bankClearingCode: false,
            bankCountryCode: false,
            ibanAccountNumber: false,
            bankAccountType: false,
        });
        setCustomerAddress({
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            addressLine4: '',
            addressLine5: '',
            buildingNumber: '',
            ctrySubDivision: '',
            postalCode: '',
            streetNumber: '',
            townName: '',
        });
        setCustomerAddressValidation({
            streetNumber: false,
            addressLine1: false,
            townName: false,
            buildingNumber: false,
            ctrySubDivision: false,
            postalCode: false,
        });
        setEbdError(false);
    };

    const resetAddress = () => {
        setCustomerAddress({
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            addressLine4: '',
            addressLine5: '',
            buildingNumber: '',
            ctrySubDivision: '',
            postalCode: '',
            streetNumber: '',
            townName: '',
        });

        setCustomerAddressValidation({
            streetNumber: false,
            addressLine1: false,
            townName: false,
            buildingNumber: false,
            ctrySubDivision: false,
            postalCode: false,
        });
    };

    // Country Dropdown For
    const handleCountryData = (SelectedOption) => {
        resetBankAccState();
        resetAddress();
        if (SelectedOption.value === '') {
            return;
        }
        setCountry(SelectedOption);
        console.log('Selected Currency is', receiveCurrency);
        let countryCurrencyList = [];
        let count = 0;
        countriesListData.forEach((country) => {
            if (country.countryCode === SelectedOption.value) {
                countryCurrencyList.push({
                    currencyCode: country.currencyCode,
                });
                count = count + 1;
            }
        });

        if (count > 1) {
            setShowAC(false);
            setShowCurrencyD(true);
            setCurrencyList(
                countryCurrencyList.map((name) => ({
                    label: name.currencyCode,
                    value: name.currencyCode,
                }))
            );
            console.log('Multiple currencies are', countryCurrencyList);
            console.log('Customer Data is', userData);
        } else {
            console.log('Customer Data is', userData);
            setShowCurrencyD(false);
            setCurrencyList(
                countryCurrencyList.map((name) => ({
                    label: name.currencyCode,
                    value: name.currencyCode,
                }))
            );

            setReceiveCurrency(countryCurrencyList[0].currencyCode);
            console.log('Currency list is', countryCurrencyList);
            console.log('Receive currency is', receiveCurrency);
            let selectedCountry = SelectedOption.value;
            handleReceiveCurrencySelection(selectedCountry, countryCurrencyList[0].currencyCode);
        }
    };

    const handleCurrencyData = (SelectedOption) => {
        setReceiveCurrency(SelectedOption.value);
        handleReceiveCurrencySelection(country.value, SelectedOption.value);
        setCheckCurrency(false);
        setBankAccDetailsValidation({
            accountNumber: false,
            bankBic: false,
            bankClearingCode: false,
            bankCountryCode: false,
            ibanAccountNumber: false,
            bankAccountType: false,
        });
    };

    var clearingFormat = 'Clearing format'
    if (bankFieldsName !== null && bankFieldsName[0].clearingFormat) {
        clearingFormat = bankFieldsName[0].clearingFormat;
    }

    if (bankFieldsName !== null && bankFieldsName[0].accountFormat) {
        var accountFormat = bankFieldsName[0].accountFormat;
    }

    const validateBic = (bic) => {
        console.log('BIC entered by user is', bic);
        console.log('Selected country is', country);
        let countryCode = country.value;
        if (bic.length >= 6) {
            let countryCodeFromBic = bic.charAt(4) + bic.charAt(5);
            console.log('Country code from BIC is', countryCodeFromBic);
            if (countryCode.toUpperCase() === countryCodeFromBic.toUpperCase()) {
                console.log('BIC validated');
                setBankAccDetailsValidation({ ...bankAccDetailsValidation, bankBic: false });
                setBankAccDetailsErrors({ ...bankAccDetailsErrors, bankBic: '' });
            } else {
                console.log('Show BIC error');
                setBankAccDetailsValidation({ ...bankAccDetailsValidation, bankBic: true });
                let inlineBicError = t('paymentBankDetails.inlineBicError');
                setBankAccDetailsErrors({ ...bankAccDetailsErrors, bankBic: inlineBicError });
            }
        }
    };

    const validateIban = (iban) => {
        console.log('IBAN entered by user is', iban);
        console.log('Selected country is', country);
        let countryCode = country.value;
        if (iban.length >= 2) {
            let countryCodeFromIban = iban.charAt(0) + iban.charAt(1);
            console.log('Country code from IBAN is', countryCodeFromIban);
            if((/\s/.test(iban) === false)){
                if (countryCode.toUpperCase() === countryCodeFromIban.toUpperCase()) {
                    console.log('Iban validated');
                    setBankAccDetailsValidation({ ...bankAccDetailsValidation, ibanAccountNumber: false });
                    setBankAccDetailsErrors({ ...bankAccDetailsErrors, ibanAccountNumber: '' });    
                }
            } else {
                if(/\s/.test(iban) === true){
                    console.log('Show Iban space error');
                    setBankAccDetailsValidation({ ...bankAccDetailsValidation, ibanAccountNumber: true });
                    let ibanSpaceError = t('paymentBankDetails.ibanSpaceError');
                    setBankAccDetailsErrors({ ...bankAccDetailsErrors, ibanAccountNumber: ibanSpaceError });    
                } else {
                    console.log('Show Iban error');
                    setBankAccDetailsValidation({ ...bankAccDetailsValidation, ibanAccountNumber: true });
                    let inlineIbanError = t('paymentBankDetails.inlineIbanError');
                    setBankAccDetailsErrors({ ...bankAccDetailsErrors, ibanAccountNumber: inlineIbanError });
                }
            }
        }
    };

    const callSubmitForExistingAccount = () => {
        var requestPayload = {
            // emailId: globalState.beneDetails.details.emailId,
            fxRate: amountFxRate.fxRate,
            transactionIds: location.state.tnxIds,
            rateId: amountFxRate.rateId,
            receiveCurrency: selectedAccountDetails.accountCurrencycode,
            totalAmount: amountFxRate.totalAmount,
            accountCurrencycode: selectedAccountDetails.accountCurrencycode,
            countryCode: selectedAccountDetails.countryCode,
            custId: location.state.custId,
            accountId: selectedAccountDetails.accountId,
        };
        console.log('coming here', requestPayload);

        const submitDetails = async () => {
            console.log('Logging SUBMIT_PAYMENT_URL request payload', requestPayload);
            try {
                const response = await axiosInstance.post(SUBMIT_PAYMENT_URL, JSON.stringify(requestPayload));
                if (response) {
                    const responseJson = response.data;
                    if (response.status === 200) {
                        console.log('Logging SUBMIT_PAYMENT_URL response', responseJson);
                        dispatch(setStagePaymentId(responseJson.stagePaymentId));
                        history.push({
                            pathname: '/verifyDetailsConfirm',
                            state: {
                                stagePaymentId: responseJson.stagePaymentId,
                            },
                        });
                    }
                }
            } catch (error) {
                console.log('Logging SUBMIT_PAYMENT_URL error', error);
            }
        };
        submitDetails();
    };

    const addressJSX = (
        <>
            <Grid container>
                <Box marginTop={['20px', '20px', '20px', '48px']} borderLeft='3px solid red' pl='10px'>
                    <Typography variant='h2'>{t('paymentBankDetails.provide_address')}</Typography>
                </Box>
            </Grid>
            <Grid container>
                <Field name='enrich-textbox-buildingNumber'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox display='flex' flexDirection='row'>
                            <Box display='inline'>
                                <FieldLabel variant='body1'>{t('paymentBankDetails.house_flat')}*</FieldLabel>
                            </Box>
                            <Box display='inline' marginLeft='0.5em'>
                                <HoverTip
                                    paddingLeft='0.5em'
                                    content={t('paymentBankDetails.hovertipHouse')}
                                    ariaLabel={t('paymentBankDetails.hovertipHouse_info')}
                                    id='enrichment-tooltip-buildingNumber'
                                />
                            </Box>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                            <TextInput
                                className={customerAddressValidation.buildingNumber ? 'hasError' : ''}
                                aria-describedby='enrich-inline-error-house'
                                value={customerAddress.buildingNumber}
                                disabled={disableTF || disablePaypalEmailAndButtons}
                                placeholder={t('paymentBankDetails.pleaseEnterHouse')}
                                onChange={(event) => {
                                    console.log('Logging Building number', event.value);
                                    handleAddressInput(event, 'buildingNumber');
                                }}
                                invalid={customerAddressValidation.buildingNumber}
                                maxLength={16}
                            />
                        </Box>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4} md={4}>
                    {customerAddressValidation.buildingNumber ? (
                        <InlineNotificationComponent id='enrich-inline-error-house' title='' content={t('paymentBankDetails.houseEmptyError')} />
                    ) : null}
                </Grid>
            </Grid>
            <Grid container>
                <Field name='enrich-textbox-addressLine1'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('paymentBankDetails.address_line_1')}*</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                            <TextInput
                                className={customerAddressValidation.addressLine1 ? 'hasError' : ''}
                                aria-describedby='enrich-inline-error-addressLine1'
                                value={customerAddress.addressLine1}
                                disabled={disableTF || disablePaypalEmailAndButtons}
                                placeholder={t('paymentBankDetails.pleaseEnterAL1')}
                                onChange={(event) => {
                                    handleAddressInput(event, 'addressLine1');
                                }}
                                invalid={customerAddressValidation.addressLine1}
                                maxLength={70}
                            />
                        </Box>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4} md={4}>
                    {customerAddressValidation.addressLine1 ? (
                        <InlineNotificationComponent
                            id='enrich-inline-error-addressLine1'
                            title=''
                            content={t('paymentBankDetails.addressLine1Empty')}
                        />
                    ) : null}
                </Grid>
            </Grid>

            <Grid container>
                <Field name='enrich-textbox-addressLine2'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('paymentBankDetails.address_line_2')}</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                            <TextInput
                                value={customerAddress.addressLine2}
                                id='enrich-textbox-addressLine2'
                                disabled={disableTF || disablePaypalEmailAndButtons}
                                placeholder={t('paymentBankDetails.pleaseEnterAL2')}
                                onChange={(event) => {
                                    handleAddressInput(event, 'addressLine2');
                                }}
                                maxLength={70}
                            />
                        </Box>
                    </Grid>
                </Field>
            </Grid>

            <Grid container>
                <Field name='enrich-textbox-addressLine3'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('paymentBankDetails.address_line_3')}</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                            <TextInput
                                value={customerAddress.addressLine3}
                                disabled={disableTF || disablePaypalEmailAndButtons}
                                placeholder={t('paymentBankDetails.pleaseEnterAL3')}
                                onChange={(event) => {
                                    handleAddressInput(event, 'addressLine3');
                                }}
                                maxLength={70}
                            />
                        </Box>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Field name='enrich-textbox-townName'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('paymentBankDetails.town')}*</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                            <TextInput
                                className={customerAddressValidation.townName ? 'hasError' : ''}
                                aria-describedby='enrich-inline-error-townName'
                                value={customerAddress.townName}
                                disabled={disableTF || disablePaypalEmailAndButtons}
                                placeholder={t('paymentBankDetails.pleaseEnterTown')}
                                onChange={(event) => {
                                    handleAddressInput(event, 'townName');
                                }}
                                invalid={customerAddressValidation.townName}
                                maxLength={35}
                            />
                        </Box>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4} md={4}>
                    {customerAddressValidation.townName ? (
                        <InlineNotificationComponent id='enrich-inline-error-townName' title='' content={t('paymentBankDetails.townCannotBeEmpty')} />
                    ) : null}
                </Grid>
            </Grid>
            <Grid container>
                <Field name='enrich-textbox-state'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1'>{t('paymentBankDetails.state_country_province')}*</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                            <TextInput
                                className={customerAddressValidation.ctrySubDivision ? 'hasError' : ''}
                                aria-describedby='enrich-inline-error-state'
                                value={customerAddress.ctrySubDivision}
                                disabled={disableTF || disablePaypalEmailAndButtons}
                                placeholder={t('paymentBankDetails.pleaseEnterState')}
                                onChange={(event) => {
                                    handleAddressInput(event, 'ctrySubDivision');
                                }}
                                invalid={customerAddressValidation.ctrySubDivision}
                                maxLength={35}
                            />
                        </Box>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4} md={4}>
                    {customerAddressValidation.ctrySubDivision ? (
                        <InlineNotificationComponent id='enrich-inline-error-state' title='' content={t('paymentBankDetails.stateCannotBeEmpty')} />
                    ) : null}
                </Grid>
            </Grid>
            <Grid container>
                <Field name='enrich-textbox-postalcode'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox marginBottom={4}>
                            <FieldLabel variant='body1'>{t('paymentBankDetails.postal_code')}*</FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']} marginBottom={4}>
                            <TextInput
                                className={customerAddressValidation.pleasEnterPostalCode ? 'hasError' : ''}
                                aria-describedby='enrich-inline-error-postalcode'
                                value={customerAddress.postalCode}
                                disabled={disableTF || disablePaypalEmailAndButtons}
                                placeholder={t('paymentBankDetails.pleasEnterPostalCode')}
                                onChange={(event) => {
                                    handleAddressInput(event, 'postalCode');
                                }}
                                invalid={customerAddressValidation.postalCode}
                                maxLength={16}
                            />
                        </Box>
                    </Grid>
                </Field>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4} md={4}>
                    {customerAddressValidation.postalCode ? (
                        <InlineNotificationComponent
                            id='enrich-inline-error-postalcode'
                            title=''
                            content={t('paymentBankDetails.postalCodeCannotBeEmpty')}
                        />
                    ) : null}
                </Grid>
            </Grid>
        </>
    );

    const canadaImageJSX = (
        <Grid item xs={12} sm={12} md={3}>
            <Box
                display='flex'
                flexDirection='column'
                backgroundColor='#E5F2F2'
                border='1px solid black'
                padding='0.5em'
                position={window.innerWidth > 960 ? 'absolute' : 'static'}
                marginLeft={['0px', '0px', '1en', '1em']}
            >
                <Box>
                    <Box>
                        <Text variant='body1'>
                            Your Canadian Bank Routing Number is a combination of 0 +
                            <span style={{ color: 'blue' }}>Financial Institution Number</span> +
                            <span style={{ color: 'red' }}>Transit (Branch) Number</span>
                        </Text>
                    </Box>
                    <Box>
                        <Text variant='body1'>You can derive Routing Number for your Canadian Bank using this format:</Text>
                    </Box>
                    <Box>
                        <Text variant='body1'>
                            0<span style={{ color: 'blue' }}>FFF</span>
                            <span style={{ color: 'red' }}>TTTTT</span> where
                        </Text>
                    </Box>
                    <Box>
                        <List listStyleType='decimal' backgroundColor='#E5F2F2'>
                            <ListItem>0 will always be the first digit in the routing number</ListItem>
                            <ListItem>
                                <Text variant='body1'>
                                    <span style={{ color: 'blue' }}>FFF</span> is the three digit Financial Institution Number identifying your bank
                                    or financial institution
                                </Text>
                            </ListItem>
                            <ListItem>
                                <Text variant='body1'>
                                    <span style={{ color: 'red' }}>TTTTT</span> is the five digit Transit (branch) number identifying the branch of
                                    your bank or financial institution
                                </Text>
                            </ListItem>
                        </List>
                    </Box>
                </Box>
                <Box>
                    <Text variant='body1'>
                        If you refer the cheque image below, the routing number would be 0<span style={{ color: 'blue' }}>004</span>
                        <span style={{ color: 'red' }}>12345</span>
                    </Text>
                </Box>
                <img src={process.env.PUBLIC_URL + '/images/canada.png'} alt={t('paymentBankDetails.canadaAltText')} width='100%' />

                <Box>
                    <Text variant='body1'>
                        Alternatively, you can search for your bank routing number manually from the bank list published by Payments Canada based upon
                        your branch address
                    </Text>
                </Box>
            </Box>
        </Grid>
    );

    const advanceBankDetailsJSX = (
        <>
            <Grid container>
                <Grid container>
                    <Box borderLeft='3px solid red' pl='10px' marginTop={['20px', '20px', '20px', '48px']}>
                        <Typography variant='h2'>{t('paymentBankDetails.provide_bank_details')}</Typography>
                    </Box>
                </Grid>
                {bankFieldsName[0].clearingFormat === 'BIC' ? (
                    <>
                        <Grid container>
                            <Field name='enrich-textbox-clearingFormat'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox display='flex' flexDirection='row'>
                                        <Box display='inline'>
                                            <FieldLabel variant='body1' id='enrich-label-clearingFormat'>
                                                {bankFieldsName[0].clearingFormat}*
                                            </FieldLabel>
                                        </Box>
                                        <Box display='inline' paddingLeft='0.5em'>
                                            <HoverTip
                                                content={t('paymentBankDetails.hovertipClearingFormat', { clearingFormat })}
                                                ariaLabel={t('paymentBankDetails.hovertipClearingFormat_info', { clearingFormat })}
                                                id='enrichment-tooltip-clearingFormat'
                                            />
                                        </Box>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box marginTop={['5px', '5px', '5px', '24px']}>
                                        <TextInput
                                            className={bankAccDetailsValidation.bankBic ? 'hasError' : ''}
                                            aria-describedby='enrich-inline-error-clearingFormat'
                                            placeholder={t('paymentBankDetails.pleaseEnterBic')}
                                            value={bankAccDetails.bankBic}
                                            disabled={disableTF || disablePaypalEmailAndButtons}
                                            onChange={(event) => {
                                                handleBankAccountUserInput(event, 'bankBic');
                                            }}
                                            onBlur={(event) => {
                                                validateBic(bankAccDetails.bankBic);
                                                handleBankAccountUserInput(event, 'bankBic', true);
                                            }}
                                            invalid={bankAccDetailsValidation.bankBic}
                                            autoFocus
                                        />
                                    </Box>
                                </Grid>
                            </Field>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={2}></Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                {bankAccDetailsValidation.bankBic ? (
                                    <InlineNotificationComponent
                                        id='enrich-inline-error-clearingFormat'
                                        title=''
                                        content={bankAccDetailsErrors.bankBic}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid container>
                            <Field name='enrich-textbox-clearingFormat'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox display='flex' flexDirection='row'>
                                        <Box display='inline'>
                                            <FieldLabel id='enrich-label-clearingFormat' variant='body1'>
                                                {bankFieldsName[0].clearingFormat}*
                                            </FieldLabel>
                                        </Box>

                                        <Box display='inline' paddingLeft='0.5em'>
                                            <HoverTip
                                                content={t('paymentBankDetails.hovertipClearingFormat', { clearingFormat })}
                                                ariaLabel={t('paymentBankDetails.hovertipClearingFormat_info', { clearingFormat })}
                                                id='enrichment-tooltip-notBic'
                                            />
                                        </Box>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box marginTop={['5px', '5px', '5px', '24px']}>
                                        <TextInput
                                            className={bankAccDetailsValidation.bankClearingCode ? 'hasError' : ''}
                                            aria-describedby='enrich-inline-error-clearingFormat'
                                            placeholder={t('paymentBankDetails.pleaseEnterClearingFormat', { clearingFormat })}
                                            value={bankAccDetails.bankClearingCode}
                                            disabled={disableTF || disablePaypalEmailAndButtons}
                                            onFocus={(event) => {
                                                console.log('Country should be canada', country);
                                                if (country !== null && country.value === 'CA' && receiveCurrency === 'CAD') {
                                                    setShowCanadaImage(true);
                                                }
                                            }}
                                            onChange={(event) => {
                                                handleBankAccountUserInput(event, 'bankClearingCode');
                                            }}
                                            onBlur={(event) => {
                                                handleBankAccountUserInput(event, 'bankClearingCode', true);
                                                setShowCanadaImage(false);
                                            }}
                                            invalid={bankAccDetailsValidation.bankClearingCode}
                                            autoFocus
                                        />
                                    </Box>
                                </Grid>
                            </Field>
                            {showCanadaImage ? canadaImageJSX : null}
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={2}></Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                {bankAccDetailsValidation.bankClearingCode ? (
                                    <InlineNotificationComponent
                                        id='enrich-inline-error-clearingFormat'
                                        title=''
                                        content={bankAccDetailsErrors.bankClearingCode}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                    </>
                )}

                {bankFieldsName[0].accountFormat === 'IBAN' ? (
                    <>
                        <Grid container>
                            <Field name='enrich-textbox-accountNumber'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1' id='enrich-label-accountNumber'>
                                            {bankFieldsName[0].accountFormat}*
                                        </FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box marginTop={['5px', '5px', '5px', '24px']}>
                                        <TextInput
                                            className={bankAccDetailsValidation.ibanAccountNumber ? 'hasError' : ''}
                                            aria-describedby='enrich-inline-error-accountNumber'
                                            placeholder={t('paymentBankDetails.pleaseEnterIban', { accountFormat })}
                                            value={bankAccDetails.ibanAccountNumber}
                                            disabled={disableTF || disablePaypalEmailAndButtons}
                                            onChange={(event) => {
                                                handleBankAccountUserInput(event, 'ibanAccountNumber');
                                            }}
                                            onBlur={(event) => {
                                                validateIban(bankAccDetails.ibanAccountNumber);
                                                handleBankAccountUserInput(event, 'ibanAccountNumber', true);
                                            }}
                                            invalid={bankAccDetailsValidation.ibanAccountNumber}
                                            autoFocus
                                        />
                                    </Box>
                                </Grid>
                            </Field>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={2}></Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                {bankAccDetailsValidation.ibanAccountNumber ? (
                                    <InlineNotificationComponent
                                        id='enrich-inline-error-accountNumber'
                                        title=''
                                        content={bankAccDetailsErrors.ibanAccountNumber}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                    </>
                ) : (
                    <>
                        <Grid container>
                            <Field name='enrich-textbox-accountNumber'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1' id='enrich-label-accountNumber'>
                                            {bankFieldsName[0].accountFormat}*
                                        </FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box marginTop={['5px', '5px', '5px', '24px']}>
                                        <TextInput
                                            className={bankAccDetailsValidation.accountNumber ? 'hasError' : ''}
                                            aria-describedby='enrich-inline-error-accountNumber'
                                            placeholder={t('paymentBankDetails.pleaseEnterAccountNumber', { accountFormat })}
                                            value={bankAccDetails.accountNumber}
                                            disabled={disableTF || disablePaypalEmailAndButtons}
                                            onChange={(event) => {
                                                handleBankAccountUserInput(event, 'accountNumber');
                                            }}
                                            onBlur={(event) => {
                                                handleBankAccountUserInput(event, 'accountNumber', true);
                                            }}
                                            invalid={bankAccDetailsValidation.accountNumber}
                                        />
                                    </Box>
                                </Grid>
                            </Field>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={2}></Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                {bankAccDetailsValidation.accountNumber ? (
                                    <InlineNotificationComponent
                                        id='enrich-inline-error-accountNumber'
                                        title=''
                                        content={bankAccDetailsErrors.accountNumber}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                    </>
                )}
                {showAccountType ? (
                    <>
                        <Grid container>
                            <Field name='enrich-dropdown-accountType'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox>
                                        <FieldLabel variant='body1' id='enrich-dropdown-accountType'>
                                            {t('paymentBankDetails.accountType')}*
                                        </FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box marginTop={['5px', '5px', '5px', '24px']}>
                                        <NativeDropdown
                                            ariaLabelledby='enrich-dropdown-accountType'
                                            className={bankAccDetailsValidation.bankAccountType ? 'hasError' : ''}
                                            ariaDescribedby='enrich-inline-error-accountType'
                                            id='enrich-dropdown-accountType-field'
                                            width='100%'
                                            disabled={disableTF || disablePaypalEmailAndButtons}
                                            options={accountTypeList}
                                            onChange={(SelectedOption, event) => {
                                                handleBankAccountType(SelectedOption, event);
                                            }}
                                            invalid={bankAccDetailsValidation.bankAccountType}
                                            defaultDisabled={true}
                                        />
                                        {/** <ReactSelect
                                            className={bankAccDetailsValidation.bankAccountType ? 'hasError' : ''}
                                            aria-describedby='enrich-inline-error-accountType'
                                            id='enrich-dropdown-accountType-field'
                                            width='100%'
                                            isDisabled={disableTF || disablePaypalEmailAndButtons}
                                            isSearchable
                                            options={accountTypeList}
                                            onChange={(SelectedOption, event) => {
                                                handleBankAccountType(SelectedOption, event);
                                            }}
                                            invalid={bankAccDetailsValidation.bankAccountType}
                                        />*/}
                                    </Box>
                                </Grid>
                            </Field>
                        </Grid>
                        <Grid container>
                            <Grid item xs={12} sm={2}></Grid>
                            <Grid item xs={12} sm={4} md={4}>
                                {bankAccDetailsValidation.bankAccountType ? (
                                    <InlineNotificationComponent
                                        id='enrich-inline-error-accountType'
                                        title=''
                                        content={bankAccDetailsErrors.bankAccountType}
                                    />
                                ) : null}
                            </Grid>
                        </Grid>
                    </>
                ) : null}

                {addressRequired ? addressJSX : null}
            </Grid>
        </>
    );

    const countryAndAmountDetailsJSX = (
        <>
            <Grid container>
                <Box marginTop={['20px', '20px', '20px', '48px']}>
                    <Box borderLeft='3px solid red' pl='10px'>
                        <Typography variant='h2'>{t('paymentBankDetails.select_country_currency')}</Typography>
                    </Box>
                </Box>
            </Grid>
            {showPrivacyNoticeBanner ? (
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <Box marginTop={['10px', '10px', '10px', '24px']}>
                            <ContextualNotification variant='info' onClose={() => setShowPrivacyNoticeBanner(false)}>
                                <Typography variant='body1' paddingBottom={2}>
                                    {t('paymentBankDetails.privacyNoticeBanner')}{' '}
                                    <Link
                                        to='privacy-notice'
                                        target='_blank'
                                        style={{ textDecoration: 'underline', color: '#333333' }}
                                        aria-label='Privacy notice (Opens in a new window)'
                                    >
                                        here ({t('footer.new_window')})
                                    </Link>
                                    .
                                </Typography>{' '}
                            </ContextualNotification>
                        </Box>
                    </Grid>
                </Grid>
            ) : null}
            <Grid container>
                <Grid item xs={12} sm={2}></Grid>
                <Grid item xs={12} sm={4}>
                    <Box marginTop={['5px', '5px', '5px', '24px']} display='flex' flexDirection='row-reverse'>
                        <Typography variant='body1'>{t('paymentBankDetails.mandatoryFields')}</Typography>
                    </Box>
                </Grid>
            </Grid>

            <Grid container>
                <Field name='enrich-dropdown-countries'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1' id='enrich-dropdown-countries'>
                                {t('paymentBankDetails.bank_location')}*
                            </FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']} style={{ widtdisableTFh: '100%' }}>
                            <NativeDropdown
                                ariaLabelledby='enrich-dropdown-countries'
                                id='enrich-dropdown-countries-field'
                                disabled={disableTF}
                                options={countriesList}
                                onChange={handleCountryData}
                                autoFocus={true}
                                width='100%'
                                selectSize='large'
                                defaultDisabled={true}
                            />
                            {/**                            <ReactSelect
                                id='enrich-dropdown-countries-field'
                                width='100%'
                                isDisabled={disableTF}
                                isSearchable
                                options={countriesList}
                                value={country}
                                onChange={handleCountryData}
                                autoFocus
                            /> */}
                        </Box>
                    </Grid>
                </Field>
            </Grid>

            <Grid container>
                <Field name='enrich-textbox-creditcurrency'>
                    <Grid item xs={12} sm={2}>
                        <LabelBox>
                            <FieldLabel variant='body1' id='enrich-textbox-creditcurrency'>
                                {t('paymentBankDetails.currency')}*
                            </FieldLabel>
                        </LabelBox>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box marginTop={['5px', '5px', '5px', '24px']} style={{ widtdisableTFh: '100%' }}>
                            {showCurrencyD ? (
                                <NativeDropdown
                                    ariaLabelledby='enrich-textbox-creditcurrency'
                                    ariaDescribedby='multiple-currency-inline-error'
                                    className={checkCurrency ? 'hasError' : ''}
                                    id='enrich-textbox-creditcurrency-field'
                                    width='100%'
                                    disabled={disableTF}
                                    options={currencyList}
                                    onChange={handleCurrencyData}
                                    defaultDisabled={true}
                                    selectSize='large'
                                />
                            ) : (
                                <TextInput id='enrich-textbox-creditcurrency' disabled={true} value={receiveCurrency} />
                            )}
                            {checkCurrency ? (
                                    <InlineNotificationComponent
                                        id='multiple-currency-inline-error'
                                        title=''
                                        content={currencyError}
                                    />
                            ) : null}
                        </Box>
                    </Grid>
                </Field>
            </Grid>
            {showAC ? (
                <>
                    <Grid container>
                        <Field name='enrich-textbox-creditamount'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1'>{t('paymentBankDetails.amount')}</FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box marginTop={['5px', '5px', '5px', '24px']}>
                                    <TextInput disabled={true} value={amount} />
                                </Box>
                            </Grid>
                        </Field>
                    </Grid>

                    <Grid container>
                        <Field name='enrich-textbox-rateused'>
                            <Grid item xs={12} sm={2}>
                                <LabelBox>
                                    <FieldLabel variant='body1'>{t('paymentBankDetails.rate_used')}</FieldLabel>
                                </LabelBox>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box marginTop={['5px', '5px', '5px', '24px']}>
                                    <TextInput disabled={true} value={fxRate} />
                                </Box>
                            </Grid>
                        </Field>
                    </Grid>
                </>
            ) : null}
        </>
    );

    const advanceWalletDetailsJSX = (
        <>
            <Grid container>
                <Grid container>
                    <Box marginTop={['20px', '20px', '20px', '48px']}>
                        <Box borderLeft='3px solid red' pl='10px'>
                            <Typography variant='h2'>{t('paymentBankDetails.provide_paypal_details')}</Typography>
                        </Box>
                    </Box>
                </Grid>

                <Grid container>
                    <Field name='enrich-textbox-paypalemail'>
                        <Grid item xs={12} sm={2}>
                            <LabelBox display='flex' flexDirection='row'>
                                <Box display='inline'>
                                    <FieldLabel variant='body1'>{walletLabel}*</FieldLabel>
                                </Box>
                                <Box display='inline' paddingLeft='0.5em'>
                                    <HoverTip
                                        content={t('paymentBankDetails.paypalEmailTooltip')}
                                        ariaLabel={t('paymentBankDetails.paypalEmailTooltip_info')}
                                        id='enrichment-tooltip-wallet'
                                    />
                                </Box>
                            </LabelBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Box marginTop={['5px', '5px', '5px', '24px']}>
                                <TextInput
                                    className={showEmailError && emailError ? 'hasError' : ''}
                                    aria-describedby='email-inline-error'
                                    disabled={disablePaypalEmailAndButtons}
                                    placeholder={t('paymentBankDetails.pleaseEnterPaypalEmailId')}
                                    onChange={(event) => {
                                        if (event.value !== '' || event.value !== null) {
                                            setShowEmailError(false);
                                            setEmailError('');
                                        }
                                        setPaypalEmailId(event.value);
                                    }}
                                    invalid={showEmailError && emailError}
                                    autoFocus
                                />
                            </Box>
                        </Grid>
                    </Field>
                    <Grid container>
                        <Grid item xs={12} sm={2}></Grid>
                        {showEmailError && emailError !== '' ? (
                            <Grid item xs={12} sm={4}>
                                <InlineNotificationComponent id='email-inline-error' title='' content={emailError} />
                            </Grid>
                        ) : null}
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} sm={2}></Grid>
                        <Grid item xs={12} sm={4}>
                            <Box marginTop={['10px', '10px', '10px', '10px']}>
                                <Typography variant='body1'>{t('paymentBankDetails.paypal_label')}</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {addressRequired ? addressJSX : null}
        </>
    );

    const confirmCheckboxJSX = (
        <Grid container>
            <Box display='flex' flex='row' marginTop={['10px', '10px', '10px', '24px']} maxWidth='600px'>
                <NativeCheckbox
                    id='enrich-checkbox-tnc'
                    ariaDescribedby='enrich-checkbox-tnc-error'
                    hasError={showPrivacyNoticeError}
                    className={confirmDetails ? '' : 'hasError'}
                    checked={confirmDetails}
                    variant='light.small'
                    disabled={disableTF}
                    onChange={(event) => {
                        toggleConfirmDetailsCheckbox(event);
                    }}
                    label={
                        <Typography variant='body1'>
                            {'I confirm that the details provided above relates to my own account I have read and accepted the'.concat(' ')}
                            <Link
                                target='_blank'
                                to='bsm-terms-and-conditions'
                                style={{ color: 'black', textDecoration: 'underline' }}
                                aria-label={t('paymentBankDetails.privacyNotice') + " " + t('footer.new_window')}
                            >
                                {t('paymentBankDetails.privacyNotice')} ({t('footer.new_window')})
                            </Link>
                        </Typography>
                    }
                />
            </Box>
            <Grid container>
                {showPrivacyNoticeError ? (
                    <Box paddingTop={['10px', '10px', '10px', '0.7em']}>
                        <InlineNotificationComponent
                            id='enrich-checkbox-tnc-error'
                            title=''
                            content={t('paymentBankDetails.pleaseAcceptPrivacyNotice')}
                        />
                    </Box>
                ) : null}
            </Grid>
        </Grid>
    );

    const sendPasswordJSX = (
        <Grid container>
            <Grid container>
                <Box
                    display='flex'
                    flexDirection='row'
                    justifyContent='space-between'
                    width='100%'
                    maxWidth='650px'
                    paddingTop='1em'
                    borderTop='1px solid #333'
                >
                    <Button
                        id='enrich-button-cancel-paymentslist'
                        variant='light.tertiary'
                        onClick={() => {
                            history.push('payments-list-guest');
                        }}
                    >
                        {t('paymentBankDetails.cancel')}
                    </Button>
                    <Button
                        id='enrich-button-sendotp'
                        onClick={(event) => {
                            callSubmit(event);
                        }}
                        variant='light.primary'
                    >
                        {t('paymentBankDetails.send_otp')}
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
    /**
     * Shown in both Paypal and Bank,
     * OTP Field JSX
     * Continue Buttom
     */
    const passwordFieldJSX = (
        <Box width='100%'>
            <Grid container>
                <Grid container>
                    <Box marginTop={['10px', '10px', '10px', '24px']}>
                        <Box borderLeft='3px solid red' pl='10px' maxWidth='600px'>
                            <Typography variant='h2'>{t('paymentBankDetails.input_emailed_password', { paymentMethod })}</Typography>
                        </Box>
                    </Box>
                </Grid>

                <Grid container>
                    <Field name='enrich-textbox-otp'>
                        <Grid item xs={12} sm={2}>
                            <LabelBox>
                                <FieldLabel variant='body1'>{t('paymentBankDetails.otp')}*</FieldLabel>
                            </LabelBox>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Box marginTop={['5px', '5px', '5px', '24px']}>
                                <TextInput
                                    aria-describedby='otp-inline-error'
                                    type='password'
                                    value={otp}
                                    onChange={(event) => {
                                        setOtp(event.value);
                                    }}
                                    placeholder={t('paymentBankDetails.pleaseEnterOTP')}
                                    autoFocus
                                />
                            </Box>
                        </Grid>
                    </Field>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={2}></Grid>
                    <Grid item xs={12} sm={4}>
                        {showOtpError && otpError !== '' ? (
                                                    <InlineNotificationComponent
                            id='otp-inline-error'
                            title=''
                            content={otpError}
                        />
                        ) : null}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={2}></Grid>
                    <Grid item xs={12} sm={4}>
                        <Button
                            marginTop={['5px', '5px', '5px', '15px']}
                            variant='light.tertiary'
                            id='enrich-button-resendpassword'
                            onClick={() => {
                                resendOtp();
                            }}
                        >
                            {t('paymentBankDetails.resend_password')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container>
                <Box
                    paddingTop={['5px', '5px', '15px', '1em']}
                    marginTop={['5px', '5px', '15px', '1em']}
                    display='flex'
                    flexDirection='row'
                    justifyContent='space-between'
                    width='100%'
                    maxWidth='650px'
                    borderTop='1px solid #333'
                >
                    <Box marginRight={2}>
                        <Button
                            variant='light.tertiary'
                            id='enrich-button-cancel'
                            onClick={() => {
                                history.push('payments-list-guest');
                            }}
                        >
                            {t('paymentBankDetails.cancel')}
                        </Button>
                    </Box>
                    <Box>
                        <Button id='enrich-button-continue' onClick={() => confirmOtp()} variant='light.primary'>
                            {t('paymentBankDetails.continue')}
                        </Button>
                    </Box>
                </Box>
            </Grid>
        </Box>
    );

    const bankDetails = showBankDetails ? countryAndAmountDetailsJSX : null;
    const paypalDetails = showPaypalDetails ? countryAndAmountDetailsJSX : null;
    const advanceBankDetails = showAdvanceBankDetails ? advanceBankDetailsJSX : null;
    const advanceWalletDetails = showAdvanceWalletDetails ? advanceWalletDetailsJSX : null;
    const passwordField = showPassword ? passwordFieldJSX : null;
    const continueField = !showPassword && country && paymentMethod ? sendPasswordJSX : null;

    return (
        <PaymentBankDetailsPlaceholder style={{ paddingBottom: `${footerHeight + 20}px` }}>
            <Grid container>
                <Grid container>
                    <CustomerLogo />
                    <Grid container>
                        <Box>
                            <Box borderLeft='3px solid red' paddingLeft='10px'>
                                <Typography variant='h1' id='enrich-sectionTitle' className='page-title' tabIndex='-1'>
                                    {t('paymentBankDetails.payment_bank_details')}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm='auto'>
                                <Box marginTop={['10px', '10px', '10px', '24px']}>
                                    <Button
                                        id='enrich-button-paymentslist'
                                        variant='light.tertiary'
                                        onClick={() => {
                                            history.push('payments-list-guest');
                                        }}
                                    >
                                        {t('paymentBankDetails.paymentsList')}
                                    </Button>
                                </Box>
                            </Grid>
                            {isRegisteredUser ? (
                                <Grid item xs={12} sm='auto'>
                                    <Box marginTop={['10px', '10px', '10px', '24px']}>
                                        <Button
                                            id='button-account-history'
                                            variant='light.tertiary'
                                            onClick={() => {
                                                history.push(ACCOUNT_HISTORY);
                                            }}
                                        >
                                            {t('userTable.accounts')}
                                        </Button>
                                    </Box>
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>

                    {!singlePayment && transactions !== null ? (
                        <>
                            <Grid container>
                                <Box marginTop={['10px', '10px', '10px', '24px']} width='100%'>
                                    <DefaultTable id='enrich-table-multipleselection' data={transactions} columns={multiplePaymentsColumns} />
                                </Box>
                            </Grid>
                        </>
                    ) : null}

                    {singlePayment ? (
                        <>
                            <Grid container>
                                <Field name='enrich-textbox-payername'>
                                    <Grid item xs={12} sm={2}>
                                        <LabelBox marginTop={['10px', '10px', '10px', '24px']}>
                                            <FieldLabel variant='body1'>{t('paymentBankDetails.payer_name')}</FieldLabel>
                                        </LabelBox>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                                            <TextInput value={userData.payer_name} disabled={true} />
                                        </Box>
                                    </Grid>
                                </Field>
                            </Grid>

                            <Grid container>
                                <Field name='enrich-textbox-amount'>
                                    <Grid item xs={12} sm={2}>
                                        <LabelBox marginTop={['10px', '10px', '10px', '24px']}>
                                            <FieldLabel variant='body1'>{t('paymentBankDetails.amount')}</FieldLabel>
                                        </LabelBox>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                                            <TextInput value={userData.amount} disabled={true} />
                                        </Box>
                                    </Grid>
                                </Field>
                            </Grid>

                            <Grid container>
                                <Field name='enrich-textbox-currency'>
                                    <Grid item xs={12} sm={2}>
                                        <LabelBox marginTop={['10px', '10px', '10px', '24px']}>
                                            <FieldLabel variant='body1'>{t('paymentBankDetails.currency')}</FieldLabel>
                                        </LabelBox>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                                            <TextInput value={userData.currency} disabled={true} />
                                        </Box>
                                    </Grid>
                                </Field>
                            </Grid>

                            <Grid container>
                                <Field name='enrich-textbox-paymentdetails'>
                                    <Grid item xs={12} sm={2}>
                                        <LabelBox marginTop={['10px', '10px', '10px', '24px']}>
                                            <FieldLabel variant='body1'>{t('paymentBankDetails.payment_details')}</FieldLabel>
                                        </LabelBox>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                                            <TextInput value={userData.payment_details} disabled={true} />
                                        </Box>
                                    </Grid>
                                </Field>
                            </Grid>

                            <Grid container>
                                <Field name='enrich-textbox-payerReference'>
                                    <Grid item xs={12} sm={2}>
                                        <LabelBox>
                                            <FieldLabel variant='body1'>{t('paymentBankDetails.payment_reference')}</FieldLabel>
                                        </LabelBox>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Box marginTop={['5px', '5px', '5px', '24px']}>
                                            <TextInput value={userData.payer_reference} disabled={true} />
                                        </Box>
                                    </Grid>
                                </Field>
                            </Grid>
                        </>
                    ) : null}

                    {isRegisteredUser && accountList.length !== 0 ? (
                        <Grid container>
                            <Field name='enrich-dropdown-accounts'>
                                <Grid item xs={12} sm={2}>
                                    <LabelBox marginTop={['10px', '10px', '10px', '24px']}>
                                        <FieldLabel variant='body1' id='enrich-dropdown-accounts'>
                                            {t('paymentBankDetails.account_dropdown_label')}
                                        </FieldLabel>
                                    </LabelBox>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Box marginTop={['5px', '5px', '5px', '24px']}>
                                        <NativeDropdown
                                            ariaLabelledby='enrich-dropdown-accounts'
                                            id='enrich-dropdown-accounts-field'
                                            width='100%'
                                            disabled={disablePaypalEmailAndButtons}
                                            options={accountList}
                                            onChange={(SelectedOption) => {
                                                handleRegisteredAccountChange(SelectedOption);
                                            }}
                                            defaultDisabled={true}
                                        />
                                        {/**                                        <ReactSelect
                                            id='enrich-dropdown-accounts-field'
                                            width='100%'
                                            isSearchable
                                            value={selectedRegisteredAccount}
                                            isDisabled={disablePaypalEmailAndButtons}
                                            options={accountList}
                                            onChange={(SelectedOption, event) => {
                                                handleRegisteredAccountChange(SelectedOption, event);
                                            }}
                                        /> */}
                                    </Box>
                                </Grid>
                            </Field>
                        </Grid>
                    ) : null}

                    <Grid container>
                        <Grid item xs={12} sm={2}>
                            <LabelBox>
                                <Typography variant='body1'>{t('paymentBankDetails.accountDetails')}</Typography>
                            </LabelBox>
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <Box display='flex' flexDirection='row'>
                                <Box marginTop={['10px', '10px', '10px', '24px']} marginRight={['0px', '0px', '1px', '5px']}>
                                    <Button
                                        disabled={disablePaypalEmailAndButtons}
                                        id='enrich-button-paybank'
                                        variant='light.tertiary'
                                        onClick={() => {
                                            handleBankAccount();
                                            setShowEnrichExistingFields(false);
                                            setSelectedRegisteredAccount({
                                                label: 'Pay to Existing Bank or Paypal Account',
                                                value: null,
                                            });
                                        }}
                                    >
                                        <Typography
                                            variant='body1'
                                            style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}
                                        >
                                            {isRegisteredUser && accountList.length !== 0
                                                ? t('paymentBankDetails.pay_to_new_bank_label')
                                                : t('paymentBankDetails.pay_to_new_bank_account')}
                                        </Typography>
                                    </Button>
                                </Box>
                                {showPaypalButton ? (
                                    <Box marginTop={['10px', '10px', '10px', '24px']} marginLeft={['0px', '0px', '1px', '5px']}>
                                        <Button
                                            disabled={disablePaypalEmailAndButtons}
                                            id='enrich-button-paypal'
                                            variant='light.tertiary'
                                            onClick={() => {
                                                handleWallet();
                                                setShowEnrichExistingFields(false);
                                                setSelectedRegisteredAccount({
                                                    label: 'Pay to Existing Bank or Paypal Account',
                                                    value: null,
                                                });
                                            }}
                                        >
                                            <Typography
                                                variant='body1'
                                                style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center' }}
                                            >
                                                {isRegisteredUser && accountList.length !== 0
                                                    ? t('paymentBankDetails.pay_to_new_paypal_label')
                                                    : t('paymentBankDetails.pay_to_new_paypal_account')}
                                            </Typography>
                                        </Button>
                                    </Box>
                                ) : null}
                            </Box>
                        </Grid>
                    </Grid>
                    {amountFxRate.totalAmount && showEnrichExistingFields ? (
                        <>
                            <EnrichWithExistingAccountFields
                                selectedRegisteredAccountType={selectedRegisteredAccountType}
                                selectedAccountDetails={selectedAccountDetails}
                                amountFxRate={amountFxRate}
                                bankConfiguration={bankConfiguration}
                                walletConfiguration={walletConfiguration}
                            />
                            <Grid container>
                                <Grid container>
                                    <Box
                                        display='flex'
                                        flexDirection='row'
                                        justifyContent='space-between'
                                        width='100%'
                                        maxWidth='650px'
                                        paddingTop='1em'
                                        mt={4}
                                        borderTop='1px solid #333'
                                    >
                                        <Button
                                            id='enrich-button-cancel-paymentslist'
                                            variant='light.tertiary'
                                            onClick={() => {
                                                history.push('payments-list-guest');
                                            }}
                                        >
                                            {t('paymentBankDetails.cancel')}
                                        </Button>
                                        <Button
                                            id='enrich-button-sendotp'
                                            onClick={(event) => {
                                                callSubmitForExistingAccount();
                                            }}
                                            variant='light.primary'
                                        >
                                            {t('paymentBankDetails.continue')}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </>
                    ) : null}
                    {bankDetails}
                    {paypalDetails}
                </Grid>
            </Grid>
            {advanceBankDetails}
            {advanceWalletDetails}
            {showSubmitPaymentError ? (
                <SystemNotification
                    id='enrich-system-error'
                    title='System Error'
                    variant='error'
                    onClose={() => {
                        setShowSubmitPaymentError(false);
                    }}
                >
                    {submitPaymentError}
                </SystemNotification>
            ) : null}
            {country && paymentMethod ? confirmCheckboxJSX : null}
            {passwordField}
            {continueField}
            <Modal
                open={isOpen}
                onHide={() => setOpen(false)}
                closeIcon={true}
                onClickCloseIcon={() => setOpen(false)}
                size='small'
                activeFocusTrap={true}
                aria-labelledby='title1'
                minHeight='230px'
            >
                <Box>
                    <Typography variant='body1'>{ebdTimeoutMessage}</Typography>
                </Box>
                <Box
                    position='absolute'
                    bottom='0'
                    py='20px'
                    width='calc(100% - 80px)'
                    display='flex'
                    justifyContent='center'
                    borderTop='1px solid #333'
                >
                    <Button variant='light.primary' onClick={() => setOpen(false)}>
                        OK
                    </Button>
                </Box>
            </Modal>
        </PaymentBankDetailsPlaceholder>
    );
};

export default PaymentBankDetails;